import i18next from 'i18next'
import * as React from 'react'
import { Link } from 'widgets-for-react'
import { routeUpdaters } from '../routes/routesState'

const BannerText = (props: BannerLayoutProps) => {
  switch (props.kind) {
    case 'signup-success':
      return (
        <>
          {i18next.t('auth:signupSuccesBannerA', {
            trialDaysLeft: props.trialDaysLeft,
          })}{' '}
          {/* <Link to={routeUpdaters(i18next.language).upgrade.url}>
            {i18next.t('auth:signupSuccesBannerB')}
          </Link> */}
        </>
      )
    case 'premium':
      return (
        <>
          {i18next.t('component:firstVisitBannerPremiumA')}{' '}
          <Link
            to={
              routeUpdaters(i18next.language).register.url +
              '?originPath=' +
              window.location.pathname
            }
          >
            {i18next.t('component:firstVisitBannerPremiumB')}
          </Link>
        </>
      )
    case 'public-register':
      return (
        <>
          {i18next.t('component:firstVisitBannerPublicLoggedOutA')}{' '}
          <Link
            to={
              routeUpdaters(i18next.language).register.url +
              '?originPath=' +
              window.location.pathname
            }
          >
            {i18next.t('component:firstVisitBannerPublicLoggedOutB')}
          </Link>
        </>
      )
    case 'public-subscribe':
      return (
        <>
          {i18next.t('component:firstVisitBannerPublicLoggedInA')}{' '}
          <Link to={routeUpdaters(i18next.language).upgrade.url}>
            {i18next.t('component:firstVisitBannerPublicLoggedInB')}
          </Link>
        </>
      )
    default:
      return <></>
  }
}

type BannerLayoutProps =
  | {
      kind: 'premium' | 'public-register' | 'public-subscribe'
    }
  | { kind: 'signup-success'; trialDaysLeft: number }

export const BannerLayout = (props: BannerLayoutProps) => (
  <div className={`banner banner--${props.kind}`}>
    <div className="banner__inner container--m gutter--m">
      <div className="banner__content text--styled">
        <p className="banner__text">
          <BannerText {...props} />
        </p>
      </div>

      <div className="banner__visual fit-object" aria-hidden="true">
        <img
          className="banner__image"
          src="/spa/images/banner-placeholder.jpg"
          width="988"
          height="660"
          alt=""
        />
        <svg
          className="banner__shape"
          preserveAspectRatio="none"
          viewBox="0 0 280 160"
          width="280"
          height="160"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="m869.16222 196.257516 380-218.5000003-380-218.4999997 62.185436 197.3751997v232.4766593z"
            fill="#f5f4f2"
            fillRule="evenodd"
            transform="translate(-931)"
          />
        </svg>
      </div>
    </div>
  </div>
)
